// Central helper to prune persisted UI state (filters/grid/view) by key prefix.
export class StateCleaner {
    /** Remove keys that start with any of the given prefixes from the given storages. */
    static clearByPrefixes(
        prefixes: string[],
        storages: Storage[] = [sessionStorage]   // default: sessionStorage only
    ): void {
        const shouldRemove = (k: string) => prefixes.some(p => k.startsWith(p));

        for (const storage of storages) {
            const toRemove: string[] = [];
            for (let i = 0; i < storage.length; i++) {
                const k = storage.key(i);
                if (k && shouldRemove(k)) toRemove.push(k);
            }
            toRemove.forEach(k => storage.removeItem(k));
        }
    }

    /** Remove all configuration state (everything under "cfg/"). */
    static clearCfgAll(storages: Storage[] = [sessionStorage]): void {
        this.clearByPrefixes(['cfg/'], storages);
    }

    /** Remove legacy UI-state keys (everything under "config."). */
    static clearLegacyConfigAll(storages: Storage[] = [sessionStorage]): void {
        this.clearByPrefixes(['config.'], storages);
    }

    /** Convenience: clear both new ("cfg/") and legacy ("config.") UI state. */
    static clearUiStateAll(storages: Storage[] = [sessionStorage]): void {
        this.clearByPrefixes(['cfg/', 'config.'], storages);
    }

    /** Remove only a specific configuration namespace, e.g. "inventory" or "types". */
    static clearCfgNamespace(namespace: string, storages: Storage[] = [sessionStorage]): void {
        const prefix = namespace.endsWith('/') ? `cfg/${namespace}` : `cfg/${namespace}/`;
        this.clearByPrefixes([prefix], storages);
    }

    /** Remove several namespaces at once. */
    static clearCfgNamespaces(namespaces: string[], storages: Storage[] = [sessionStorage]): void {
        const prefixes = namespaces.map(ns => ns.endsWith('/') ? `cfg/${ns}` : `cfg/${ns}/`);
        this.clearByPrefixes(prefixes, storages);
    }

    /** Remove exact keys if you ever need to snipe specific entries. */
    static clearExact(keys: string[], storages: Storage[] = [sessionStorage]): void {
        for (const storage of storages) keys.forEach(k => storage.removeItem(k));
    }
}
